module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Files/Media-34f4c3fe0a4877a2544de152d652e249be9d59efaddff7875f6c2c72347f2406.svg";